import { Chip } from "@mui/material";
import GridListItem from "components/common/grid/GridListItem";
import React from "react";

const BenchmarkBillingFlag = ({ newProfileInfo }) => {
  return (
    <GridListItem
      title="IDTF"
      subTitle={
        newProfileInfo?.idtf !== null ? (
          <Chip
            color={newProfileInfo?.idtf ? "secondary" : "default"}
            label={
              <span className="d-flex align-items-center text-normal">
                {newProfileInfo?.idtf ? "YES" : "NO"}
              </span>
            }
            style={{ padding: "0px 5px", marginBottom: 5 }}
          />
        ) : (
          "—"
        )
      }
      size="3"
    />
  );
};

export default BenchmarkBillingFlag;
